// extracted by mini-css-extract-plugin
export var divider = "_fv-7";
export var itemsToggle = "_fv-8";
export var mergeModal = "_fv-1";
export var optionCard = "_fv-4";
export var radioGroup = "_fv-6";
export var radioOption = "_fv-0";
export var selected = "_fv-5";
export var shipmentOptions = "_fv-2";
export var tableOptions = "_fv-3";